import type { AnalyticsEvent } from "./analytics-events";
import { ECOMMERCE_EVENTS } from "./ecommerce";

/** The only module that touches `window.dataLayer`. */
declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/** Must match the container's configured name. */
const DATA_LAYER_NAME = "dataLayer";

/**
 * Pushes an event, and does nothing on the server — callers never guard, because
 * a missed event must not break the interaction it came from.
 */
export function track(event: AnalyticsEvent): void {
  if (typeof window === "undefined") return;

  try {
    const currentSink = window[DATA_LAYER_NAME];
    const sink = Array.isArray(currentSink) ? currentSink : [];
    if (sink !== currentSink) window[DATA_LAYER_NAME] = sink;
    // An e-commerce event is preceded by a clean `ecommerce`, or the items of the last one would
    // leak into this one and the average ticket would come out wrong (INST §10).
    if (ECOMMERCE_EVENTS.has(event.event)) sink.push({ ecommerce: null });
    sink.push({ ...event });
  } catch {
    // Analytics is best-effort and must never alter the tracked interaction.
  }
}
